var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? [
                _c("div", { staticClass: "flex flex_gap_10" }, [
                  _c("div", { staticClass: "form-check" }, [
                    _c("label", [_vm._v("Сортировка")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.sortAlias,
                            expression: "sortAlias",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.sortAlias = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.updateSortRecords,
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "maxDiff" } }, [
                          _vm._v("Максимальная разница в продажах"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "maxSold" } }, [
                          _vm._v("Максимальная продажи"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.showSales,
                            expression: "showSales",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.showSales)
                            ? _vm._i(_vm.showSales, null) > -1
                            : _vm.showSales,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.showSales,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.showSales = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.showSales = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.showSales = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" показать продажи\n            "),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm.paginator
                      ? _c("PaginationBlock", {
                          attrs: {
                            paginator: _vm.paginator,
                            "get-records": _vm.getRecords,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-0" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { attrs: { rowspan: "2" } }),
                        _vm._v(" "),
                        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("ID")]),
                        _vm._v(" "),
                        _c("th", { attrs: { rowspan: "2" } }, [
                          _vm._v("препарат"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-center border-right",
                            attrs: { colspan: _vm.showSales ? 2 : 1 },
                          },
                          [
                            _vm._v(
                              "c\n              " +
                                _vm._s(
                                  _vm.printDate(_vm.historyDate, "DD.MM.YYYY")
                                ) +
                                " -\n              " +
                                _vm._s(_vm.soldDays) +
                                " дней\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: _vm.showSales ? 2 : 1 },
                          },
                          [
                            _vm._v(
                              "c " +
                                _vm._s(
                                  _vm.printDate(_vm.startDate, "DD.MM.YYYY")
                                ) +
                                "\n              (" +
                                _vm._s(_vm.presentDaysDiff) +
                                ")\n            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm.showSales
                          ? _c("th", { attrs: { align: "right" } }, [
                              _vm._v("продано"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "border-right",
                            attrs: { align: "right" },
                          },
                          [_vm._v("в день")]
                        ),
                        _vm._v(" "),
                        _c("th", [_vm._v("в день")]),
                        _vm._v(" "),
                        _vm.showSales
                          ? _c("th", [_vm._v("продажи")])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (r, i) {
                        return _c(
                          "tr",
                          {
                            key: r.drug_id,
                            class: {
                              marked_tr: r.last_sold_rate > r.preset_sold_rate,
                            },
                          },
                          [
                            _c("td", [_vm._v(_vm._s(i + 1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(r.drug_id))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(r.title))]),
                            _vm._v(" "),
                            _vm.showSales
                              ? _c("td", { attrs: { align: "right" } }, [
                                  _vm._v(_vm._s(r.total_qty)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "border-right",
                                attrs: { align: "right" },
                              },
                              [_vm._v(_vm._s(r.last_sold_rate))]
                            ),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(r.preset_sold_rate))]),
                            _vm._v(" "),
                            _vm.showSales
                              ? _c("td", [_vm._v(_vm._s(r.present_sold))])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("PaginationBlock", {
                    attrs: {
                      paginator: _vm.paginator,
                      "get-records": _vm.getRecords,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }